import { useContext } from 'react';

import Energy from '@/components/game/3d/object/piece/Energy';
import { GameContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import { getPlayerStateWithId } from '@/util/player';
import { getColorfromChar } from '@/util/season';

const SummitWinnerBuilder = () => {
	const { playerStateArray, summitWinners }: any = useContext(GameContext);
	if (summitWinners == null || summitWinners.length <= 0) {
		return;
	}
	logg(summitWinners);
	const winnerEnergyArray: any = [];
	const sc = 0.9;

	// needs to be a 2d array
	for (let i = 0; i < summitWinners.length; i++) {
		if (summitWinners[i].length < playerStateArray.length) {
			for (let j = 0; j < summitWinners[i].length; j++) {
				const pState = getPlayerStateWithId(
					playerStateArray,
					summitWinners[i][j]
				);
				pState &&
					winnerEnergyArray.push(
						<group
							key={`summit_winner_group_${i}`}
							position={[1.5 + i * 2.25, -0.5 + j, -3]}
							scale={[sc, sc, sc]}
						>
							<Energy
								key={`summit_winner_${i}`}
								energyColor={getColorfromChar(
									pState.energyColor
								)}
							/>
						</group>
					);
			}
		}
	}

	if (!summitWinners) return;

	return <>{winnerEnergyArray}</>;
};

export default SummitWinnerBuilder;
